import { useTranslation } from 'react-i18next';

export default function DrinksSection({
    drinks,
    onChange,
    lang,
    manual,
    idpropiedad
}) {

    const { t } = useTranslation();

    return (

        <>

            <h2 className="u-align-center u-form-group u-form-text u-label-none u-text u-text-7 fontmontserrat">{t("Bebidas")}</h2>
            <p className="u-align-center fontmontserrat" style={{ marginLeft: "30px" }}>{t("Las bebidas no están incluidas en el precio del chárter. Estaremos encantados de aprovisionar a bordo las bebidas que deseen. Estas se comprarán previamente y se entregará una factura detallada a su llegada. El pago se realizará en el momento del embarque. Algunas goletas disponen de servicio de bar a bordo y, en esos casos, no está permitido introducir bebidas del exterior.")}
                {manual && manual[lang] ?
                    manual[lang].url && manual[lang].url != "" ?
                        <>
                            <br /><a href={manual[lang].url} target="_blank" className="fontmontserrat"><i className="fa-duotone fa-arrow-up-right-from-square" aria-hidden="true"></i> {t("Lista de precios de bebidas")}</a>
                        </>
                        :
                        manual[lang].file && manual[lang].file != "" ?
                            <>
                                <br /><a href={`/checkin/propiedad/descargaDocumento/${idpropiedad}/${manual[lang].file}/${lang}`} target="_blank" className="fontmontserrat"><i className="fa-duotone fa-download" aria-hidden="true"></i> {t("Lista de precios de bebidas")}</a >
                            </>
                            :
                            ""
                    :
                    ""
                }
            </p>
            <div className="u-form-group u-form-name u-label-none">
                <label htmlFor="drinks" className="u-form-control-hidden u-label">{t("Nombre, marca, cantidad...")}</label>
                <textarea
                    rows="6"
                    placeholder={t("Indique las bebidas que desean solicitar (nombre, marca, cantidad, etc")}
                    value={drinks}
                    onChange={(e) => onChange(e.target.value)}
                    required
                    id="drinks"
                    name="drinks"
                    className="u-border-2 u-border-black u-border-no-left u-border-no-right u-border-no-top u-input u-input-rectangle"
                />
            </div>
        </>

    );

}
